
import { Button } from '@/components/ui/button';
import { MapPin, Home, RefreshCw, Plus } from 'lucide-react';
import StationFilters, { FilterOptions } from '@/components/StationFilters';
import { useNavigate } from 'react-router-dom';
import { buttonHover } from '@/components/ui/animations';
import { useIsIOS } from '@/hooks/use-ios';

interface StationControlsProps {
  showMap: boolean;
  showHomeOnly: boolean;
  isRefreshing: boolean;
  onToggleMap: () => void;
  onToggleHomeOnly: () => void;
  onRefresh: () => void;
  onFilterChange: (filters: FilterOptions) => void;
}

const StationControls = ({
  showMap,
  showHomeOnly,
  isRefreshing,
  onToggleMap,
  onToggleHomeOnly,
  onRefresh,
  onFilterChange,
}: StationControlsProps) => {
  const navigate = useNavigate();
  const isIOS = useIsIOS();

  return (
    <div className={`flex flex-wrap justify-between items-start gap-6 my-6 p-6 bg-gradient-to-r from-white to-gray-50 rounded-xl shadow-sm border border-gray-100 transition-all duration-300 hover:shadow-md ${isIOS ? 'ios-nav-padding' : ''}`}>
      <div className="flex gap-3 flex-wrap items-center">
        <Button 
          variant={showMap ? "default" : "outline"}
          className={`flex items-center gap-2 ${buttonHover} touch-manipulation`}
          onClick={onToggleMap}
        >
          <MapPin className="h-4 w-4" />
          <span>{showMap ? 'List View' : 'Map View'}</span>
        </Button>
        
        <Button 
          variant={showHomeOnly ? "default" : "outline"}
          className={`flex items-center gap-2 ${buttonHover} touch-manipulation`}
          onClick={onToggleHomeOnly}
        >
          <Home className="h-4 w-4" />
          <span>Home Chargers</span>
        </Button>
        
        <StationFilters onFilterChange={onFilterChange} />
        
        <Button
          variant="outline"
          className={`flex items-center gap-2 ${buttonHover} touch-manipulation`}
          onClick={onRefresh}
          disabled={isRefreshing}
        >
          <RefreshCw className={`h-4 w-4 ${isRefreshing ? 'animate-spin' : ''}`} />
          <span>Refresh</span>
        </Button>
      </div>

      <Button 
        className={`flex items-center gap-2 bg-gradient-to-r from-primary to-blue-500 text-primary-foreground shadow-lg hover:shadow-xl hover:opacity-90 transition-all duration-300 ${buttonHover} touch-manipulation`}
        onClick={() => navigate('/host-charger')}
      >
        <Plus className="h-4 w-4" />
        <span>Host Your Charger</span>
      </Button>
    </div>
  );
};

export default StationControls;
